import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CrudRead, CrudCreate, CrudUpdate, CrudDelete } from "./crud.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [CrudCreate, CrudRead, CrudUpdate, CrudDelete],
  exports: [CrudCreate, CrudRead, CrudUpdate, CrudDelete]
})
export class CrudModule {}
